import React, { useRef, useEffect, useState, useContext, useMemo, useLayoutEffect } from 'react';
import styles from './GanttChartAll.module.css';
import Procesory from './procesory_btn/Procesory';
import { AppContext } from 'context/AppContext';
import { druk_alert } from 'actions/druk_alert';
import { useGant } from './useGant';
import { AppWindow, BetweenVerticalEnd, ChevronsLeft, ChevronsRight, Focus, FullscreenIcon, Layers, LucideGitBranchPlus, Magnet, Move, Move3D, RefreshCcw, Scaling, ScanSearchIcon, Shrink, Spline, Waypoints, X, XCircle, ZoomIn, ZoomInIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getNameOfElementTyp } from 'actions/getNameOfElementTyp';
import GanttContextMenu from './GanttContextMenu';
import ModalGrupyTechnologii from './ModalGrupyTech/ModalGrupyTechnologii';
import { TechnologyContext } from 'context/TechnologyContext';
import { updateZmienCzasTrwaniaGrupyGant } from 'actions/updateZmienCzasTrwaniaGrupyGant';
import { updateZmienCzasTrwaniaGrupyGantPrzerwa } from 'actions/updateZmienCzasTrwaniaGrupyGantPrzerwa';
import { updateZmienCzasTrwaniaGrupyOprawaGant } from 'actions/updateZmienCzasTrwaniaGrupyOprawaGant';
import { updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa } from 'actions/updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa';
import { dateISOtoPL } from 'actions/dateISOtoPL';
import { date_time } from 'actions/date_time';
import { date_bez_time } from 'actions/date_bez_time';
import { useDragDropGant } from './DragDrop/useDragDropGant';
import { useAccess } from 'hooks/useAccess';
import GanttConnections from './GanttConnections';
import GanttOprawaConnections from './GanttOprawaConnections';
import GanttSearch from './GanttSearch';
import GanttConectionSingle from './GanttConectionSingle';
import { FloatingWindows } from './FloatingWindows';

const GanttChartAll = ({ stages }) => {
  const chartRef = useRef(null);
  const scrollWrapperRef = useRef(null);
  const stageNamesListRef = useRef(null);
  
  const scrollingSource = useRef(null);
  const animFrameId = useRef(null);

  const { setGrupaWykonan } = useContext(TechnologyContext);

  const [minDate, setMinDate] = useState(null);
  const [etykieta, setEtykieta] = useState("");
  const [maxDate, setMaxDate] = useState(null);
  const [totalChartWidth, setTotalChartWidth] = useState(0);
  const [scaleFactor, setScaleFactor] = useState(0.25);

  const contextApp = useContext(AppContext);
  const procesory = contextApp.procesory;
  
  const [nowTime, setNowTime] = useState(new Date()); 
  const [colorFrom, setColorFrom] = useState(4);

  const [selectedGrup, setSelectedGrup] = useState(null);
  const [selectedZamowienieId, setSelectedZamowienieId] = useState(null);
  const [selectedShipmentDate, setSelectedShipmentDate] = useState(null);
  const [rowYPositions, setRowYPositions] = useState({});
  const {refreshGant, refreshGantAll, refreshGantZakonczone} = useGant();
  const [contextMenu, setContextMenu] = useState(null);

  const [showHourLines, setShowHourLines] = useState(true);
  const [modalGrupyOpen, setModalGrupyOpen] = useState(false);
  const [resizable, setResizable] = useState(true);
  const [moveable, setMoveable] = useState(true);

  // Stany dla obsługi przeciągania (resize) i snapowania
  const [isResizing, setIsResizing] = useState(false);
  const [resizingStage, setResizingStage] = useState(null);
  const [resizeStartX, setResizeStartX] = useState(0);
  const [currentWidthPx, setCurrentWidthPx] = useState(0);
  const [resizingEndDate, setResizingEndDate] = useState(null);
  const [resizingLeftPx, setResizingLeftPx] = useState(0);
  const [isSnapping, setIsSnapping] = useState(true);

  const navigate = useNavigate();
  const hasScrolledRef = useRef(false);

  const { handleDrop, handleDragOver, handleDragStart } = useDragDropGant(false);
  const {wolno,canDragOnGant} = useAccess(false);

  const [showAllConections, setShowAllConections] = useState(false);
  const [showElementConections, setShowElementConections] = useState(false);
  const [showOprawaConnections, setShowOprawaConnections] = useState(false);
  const [showSingleConection, setShowSingleConection] = useState(true);

  const [searchResults, setSearchResults] = useState([]); 
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchMode, setSearchMode] = useState('current'); 

  const [showFinishedBreaks, setShowFinishedBreaks] = useState(false);

  const floatingWindowsRef = useRef(null);
const [selectedProcForWindow, setSelectedProcForWindow] = useState('');
const [flashingStageId, setFlashingStageId] = useState(null);
const [openWindowsList, setOpenWindowsList] = useState([]);
const [showWindowsMenu, setShowWindowsMenu] = useState(false);

const handleAddFloatingWindow = () => {
  if (!selectedProcForWindow) return;
  floatingWindowsRef.current?.addWindow(selectedProcForWindow);
};

  // Płynna synchronizacja bez pętli zwrotnej
  const syncScroll = (source, target) => {
    if (scrollingSource.current && scrollingSource.current !== source) {
      return;
    }
    scrollingSource.current = source;
    
    if (target.current && source.current) {
      target.current.scrollTop = source.current.scrollTop;
    }

    if (animFrameId.current) {
      cancelAnimationFrame(animFrameId.current);
    }

    animFrameId.current = requestAnimationFrame(() => {
      scrollingSource.current = null;
    });
  };

  const handleMainScroll = () => {
    syncScroll(scrollWrapperRef, stageNamesListRef);
  };

  useEffect(() => {
    if (totalChartWidth > 0 && !hasScrolledRef.current) {
      const timer = setTimeout(() => {
        handleScrollToNow();
        hasScrolledRef.current = true;
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [totalChartWidth]);

  // Grupowanie etapów według procesora
  const groupedStages = useMemo(() => {
    return stages?.reduce((acc, stage) => {
      const { procesor_id } = stage;

      if (procesor_id === 51 || procesor_id === 52) {
        return acc;
      }

      if (!showFinishedBreaks && stage.typ_grupy == 1 && stage.status == 4) {
        return acc;
      }

      if (!acc[procesor_id]) {
        acc[procesor_id] = [];
      }
      acc[procesor_id].push(stage);
      return acc;
    }, {});
  }, [stages, showFinishedBreaks]);

  const processorIds = useMemo(() => Object.keys(groupedStages || {}), [groupedStages]);
  const allStagesList = useMemo(() => Object.values(groupedStages || {}).flat(), [groupedStages]);

  useEffect(() => {
    if (allStagesList && allStagesList.length > 0) {
      const allDates = allStagesList.flatMap(stage => [new Date(stage.start), new Date(stage.end)]);

      if (allDates.length === 0) return;

      const calculatedMinDate = new Date(Math.min(...allDates));
      const calculatedMaxDate = new Date(Math.max(...allDates));

      calculatedMinDate.setHours(calculatedMinDate.getHours() - 1, 0, 0, 0);
      calculatedMaxDate.setHours(calculatedMaxDate.getHours() + 180, 0, 0, 0);

      setMinDate(calculatedMinDate);
      setMaxDate(calculatedMaxDate);

      const totalTimeSpanMinutes = (calculatedMaxDate.getTime() - calculatedMinDate.getTime()) / (1000 * 60);
      setTotalChartWidth(totalTimeSpanMinutes * scaleFactor);
    }
  }, [allStagesList, scaleFactor]);

  useLayoutEffect(() => {
    if (!chartRef.current) return;
    
    const rows = chartRef.current.querySelectorAll(`.${styles.processorRow}`);
    const positions = {};

    processorIds.forEach((processorId, index) => {
      if (rows[index]) {
        positions[processorId] = rows[index].offsetTop + (rows[index].offsetHeight / 2);
      }
    });

    setRowYPositions(positions);
  }, [processorIds, totalChartWidth, scaleFactor, stages]);

  const calculateBarProperties = (start, end) => {
    if (!minDate || !maxDate || !totalChartWidth) {
      return { width: '0px', marginLeft: '0px', leftPx: 0, widthPx: 0 };
    }

    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const stageDurationMs = new Date(end).getTime() - new Date(start).getTime();
    const startOffsetMs = new Date(start).getTime() - minDate.getTime();

    const widthPx = Math.max(0, (stageDurationMs / totalTimeSpanMs) * totalChartWidth);
    const marginLeftPx = Math.max(0, (startOffsetMs / totalTimeSpanMs) * totalChartWidth);

    return {
      width: `${widthPx}px`,
      marginLeft: `${marginLeftPx}px`,
      leftPx: marginLeftPx,
      widthPx: widthPx
    };
  };

  const snapDateToNearestHour = (dateObj) => {
    const minutes = dateObj.getMinutes();
    const hours = dateObj.getHours();
    
    if (minutes >= 30) {
      dateObj.setHours(hours + 1, 0, 0, 0);
    } else {
      dateObj.setHours(hours, 0, 0, 0);
    }
    return dateObj;
  };

  const formatDateToCustomString = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!resizingStage) return;
      
      const deltaX = e.clientX - resizeStartX;

      if (!isResizing && Math.abs(deltaX) > 5) {
        setIsResizing(true);
      }

      if (!isResizing && Math.abs(deltaX) <= 5) return;

      const { widthPx: initialWidthPx, leftPx: initialLeftPx } = calculateBarProperties(resizingStage.start, resizingStage.end);
      
      const newWidth = Math.max(20, initialWidthPx + deltaX);
      setCurrentWidthPx(newWidth);
      setResizingLeftPx(initialLeftPx + newWidth);

      const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
      const durationMs = (newWidth / totalChartWidth) * totalTimeSpanMs;
      const startTimeMs = new Date(resizingStage.start).getTime();
      let currentEndTimeMs = startTimeMs + durationMs;
      
      let currentDateObj = new Date(currentEndTimeMs);
      if (isSnapping) {
        currentDateObj = snapDateToNearestHour(currentDateObj);
      }

      setResizingEndDate(currentDateObj);
    };

    const handleMouseUp = (e) => {
      if (!resizingStage) return;

      if (!isResizing) {
        setResizingStage(null);
        setResizingEndDate(null);
        return;
      }

      const deltaX = e.clientX - resizeStartX;
      const { widthPx: initialWidthPx } = calculateBarProperties(resizingStage.start, resizingStage.end);
      const finalWidthPx = Math.max(20, initialWidthPx + deltaX);

      const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
      const durationMs = (finalWidthPx / totalChartWidth) * totalTimeSpanMs;
      
      const startTimeMs = new Date(resizingStage.start).getTime();
      let newEndTimeMs = startTimeMs + durationMs;
      
      let newEndDateObj = new Date(newEndTimeMs);
      if (isSnapping) {
        newEndDateObj = snapDateToNearestHour(newEndDateObj);
      }

      const newEndDate = formatDateToCustomString(newEndDateObj);

      if (resizingStage.proces_nazwa_id == 6) {
        if (resizingStage.typ_grupy === 1) {
          updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        } else if (resizingStage.typ_grupy === 2) {
          updateZmienCzasTrwaniaGrupyOprawaGant(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        }
      } else {
        if (resizingStage.typ_grupy === 1) {
          updateZmienCzasTrwaniaGrupyGantPrzerwa(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        } else if (resizingStage.typ_grupy === 2) {
          updateZmienCzasTrwaniaGrupyGant(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        }
      }

      setIsResizing(false);
      setResizingStage(null);
      setResizingEndDate(null);
    };

    if (resizingStage) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [resizingStage, isResizing, resizeStartX, minDate, maxDate, totalChartWidth, isSnapping]);

  const getColor = (stage, technologiaId, zamowienieId) => {
    let parametr;

    if (colorFrom === 1) { 
      parametr = stage.klient_id;
      let hash = 0;
      const str = String(parametr);
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = Math.abs(hash) % 360; 
      return `hsl(${hue}, 75%, 60%)`;
    }

    if (colorFrom === 2) { 
      const hashString = `${technologiaId}-${zamowienieId}`;
      let hash = 0;
      for (let i = 0; i < hashString.length; i++) {
        hash = hashString.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = (technologiaId * 137.508) % 360;
      const saturation = 70 + (hash % 30);
      const lightness = 50 + (hash % 10);
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }

    if (colorFrom === 3) { 
      parametr = stage.data_spedycji;
      let hash = 0;
      const str = String(parametr);
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = Math.abs(hash) % 360; 
      return `hsl(${hue}, 75%, 60%)`;
    }

    if (colorFrom === 4) { 
      if (stage.typ_grupy == 1) return `linear-gradient(to bottom, #cfcfcf67 5%, #eeeeee52 50%, #cfcfcf67 90%)`;
   
      if (stage.status == 1) return `linear-gradient(to bottom, #aaaaaa7c 5%, #c9c9c97c 50%, #aaaaaa7c 90%)`;
      if (stage.status == 2) return `linear-gradient(to bottom, #a9ce54 5%, #c1e078 50%, #a9ce54 90%)`;
      if (stage.status == 3) return `linear-gradient(to bottom, #e3c956 5%, #f8df70 50%, #e3c956 90%)`;
      if (stage.status == 4 && stage.etap==16 ) return `linear-gradient(to bottom, #e116d7 5%, #e116d7 50%, #e116d7 100%)`;
      if (stage.status == 4) return `linear-gradient(to bottom, #6c7c7c 5%, #9ca8a8 50%, #6c7c7c 100%)`;
    }
  };

  const getOutlineSelected = (stage) => {
    if (stage.typ_grupy == 1) return `1px solid #cfcfcf`;
    if (stage.typ_grupy == 2) return `3px solid #4d9aff`;
  };

  const getOutline = (stage) => {
    if (stage.typ_grupy == 1) return `1px solid #cfcfcf`;
    if (stage.typ_grupy == 2) return `none`;
  };

  const renderWeekendBackgrounds = () => {
    if (!minDate || !maxDate || totalChartWidth === 0) return null;

    const weekendBlocks = [];
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();

    let currentDate = new Date(minDate);
    currentDate.setHours(0, 0, 0, 0);

    while (currentDate <= maxDate) {
      const dayOfWeek = currentDate.getDay();

      if (dayOfWeek === 6 || dayOfWeek === 0) {
        const dayStart = new Date(currentDate);
        const dayEnd = new Date(currentDate);
        dayEnd.setHours(23, 59, 59, 999);

        const actualStart = dayStart < minDate ? minDate : dayStart;
        const actualEnd = dayEnd > maxDate ? maxDate : dayEnd;

        const startOffsetMs = actualStart.getTime() - minDate.getTime();
        const durationMs = actualEnd.getTime() - actualStart.getTime();

        const leftPx = (startOffsetMs / totalTimeSpanMs) * totalChartWidth;
        const widthPx = (durationMs / totalTimeSpanMs) * totalChartWidth;

        weekendBlocks.push(
          <div
            key={`weekend-${currentDate.getTime()}`}
            className={styles.weekendOverlay}
            style={{ left: `${leftPx}px`, width: `${widthPx}px` }}
          />
        );
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return weekendBlocks;
  };

  const renderHourLines = () => {
    if (!showHourLines || !minDate || !maxDate || totalChartWidth === 0) return null;

    const lines = [];
    const interval = 24 * 60 * 60 * 1000;
    const startDate = new Date(minDate);
    startDate.setHours(0, 0, 0, 0);

    let currentDate = new Date(startDate);
    let dayIndex = 0;

    while (currentDate <= maxDate) {
      let hoursToAdd = scaleFactor < 0.3 ? [6, 18] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

      hoursToAdd.forEach((hour, hourIndex) => {
        const hourDate = new Date(currentDate);
        hourDate.setHours(hour, 0, 0, 0);

        if (hourDate >= minDate && hourDate <= maxDate) {
          const hourOffsetMs = hourDate.getTime() - minDate.getTime();
          const hourLeftPosition = (hourOffsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

          lines.push(
            <div 
              key={`grid-line-${dayIndex}-${hourIndex}-${hourDate.getTime()}`}
              className={styles.hourLineGrid}
              style={{ left: `${hourLeftPosition}px` }}
            />
          );
        }
      });

      currentDate.setTime(currentDate.getTime() + interval);
      dayIndex++;
    }
    return lines;
  };

  const renderTimelineMarkers = (prefix = 'marker') => {
    if (!minDate || !maxDate || totalChartWidth === 0) return null;

    const markers = [];
    const daysOfWeek = ['N', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So'];
    const interval = 24 * 60 * 60 * 1000;
    
    const startDate = new Date(minDate);
    startDate.setHours(0, 0, 0, 0);

    let currentDate = new Date(startDate);
    let dayIndex = 0;

    while (currentDate <= maxDate) {
      const offsetMs = currentDate.getTime() - minDate.getTime();
      const leftPosition = (offsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

      markers.push(
        <div 
          key={`${prefix}-day-${dayIndex}-${currentDate.getTime()}`} 
          className={styles.timelineMarker} 
          style={{ left: `${leftPosition}px`, transform: 'translateX(-50%)' }}
        >
          {daysOfWeek[currentDate.getDay()]} {String(currentDate.getDate()).padStart(2, '0')}/{String(currentDate.getMonth() + 1).padStart(2, '0')}
        </div>
      );

      let hoursToAdd = scaleFactor < 0.3 ? [6, 18] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

      hoursToAdd.forEach((hour, hourIndex) => {
        const hourDate = new Date(currentDate);
        hourDate.setHours(hour, 0, 0, 0);

        if (hourDate >= minDate && hourDate <= maxDate) {
          const hourOffsetMs = hourDate.getTime() - minDate.getTime();
          const hourLeftPosition = (hourOffsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

          markers.push(
            <div 
              key={`${prefix}-hour-${dayIndex}-${hourIndex}-${hourDate.getTime()}`} 
              className={styles.timelineSubMarker} 
              style={{ left: `${hourLeftPosition}px`, transform: 'translateX(-50%)' }}
            >
              {hour}:00
            </div>
          );
        }
      });

      currentDate.setTime(currentDate.getTime() + interval);
      dayIndex++;
    }
    return markers;
  };

  const calculateNowPosition = () => {
    if (!minDate || !maxDate || totalChartWidth === 0) return 0;
    const now = nowTime.getTime();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const nowOffsetMs = now - minDate.getTime();
    const leftPosition = (nowOffsetMs / totalTimeSpanMs) * totalChartWidth;
    return Math.max(0, Math.min(leftPosition, totalChartWidth));
  };

  const calculateShipmentPosition = () => {
    if (!minDate || !maxDate || totalChartWidth === 0 || !selectedShipmentDate) return 0;
    const shipmentDateObj = new Date(selectedShipmentDate);
    shipmentDateObj.setHours(6, 0, 0, 0);

    const shipmentTime = shipmentDateObj.getTime();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const shipmentOffsetMs = shipmentTime - minDate.getTime();
    const leftPosition = (shipmentOffsetMs / totalTimeSpanMs) * totalChartWidth;

    return Math.max(0, Math.min(leftPosition, totalChartWidth));
  };

  const handleScrollToNow = () => {
    if (!scrollWrapperRef.current || !minDate || !maxDate || totalChartWidth === 0) return;
    const now = new Date();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const nowOffsetMs = now.getTime() - minDate.getTime();
    const scrollPosition = (nowOffsetMs / totalTimeSpanMs) * totalChartWidth;
    scrollWrapperRef.current.scrollLeft = scrollPosition - (scrollWrapperRef.current.clientWidth / 2);
  };

const handleCenterOnStage = (stage, targetScale = null) => {
  if (!minDate || !maxDate || !totalChartWidth || !scrollWrapperRef.current) return;

  // 1. Zmieniamy skalę tylko wtedy, gdy została jawnie przekazana (np. targetScale = 0.5)
  if (targetScale !== null) {
    setScaleFactor(targetScale);
  }

  // 2. Używamy przekazanej skali LUB aktualnego scaleFactor
  const activeScale = targetScale !== null ? targetScale : scaleFactor;

  const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
  const startOffsetMs = new Date(stage.start).getTime() - minDate.getTime();
  
  const estimatedTotalWidth = ((maxDate.getTime() - minDate.getTime()) / (1000 * 60)) * activeScale;
  const stageLeftPx = (startOffsetMs / totalTimeSpanMs) * estimatedTotalWidth;
  
  const stageDurationMs = new Date(stage.end).getTime() - new Date(stage.start).getTime();
  const stageWidthPx = (stageDurationMs / totalTimeSpanMs) * estimatedTotalWidth;

  const stageCenterPx = stageLeftPx + (stageWidthPx / 2);

  setTimeout(() => {
    if (scrollWrapperRef.current) {
      const containerWidth = scrollWrapperRef.current.clientWidth;
      scrollWrapperRef.current.scrollLeft = stageCenterPx - (containerWidth / 2);
    }
  }, 50);
};

  const handleCenterOnNow = (targetScale = 0.5) => {
    if (!minDate || !maxDate || !totalChartWidth || !scrollWrapperRef.current) return;

    setScaleFactor(targetScale);

    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const now = new Date();
    const nowOffsetMs = now.getTime() - minDate.getTime();
    
    const estimatedTotalWidth = ((maxDate.getTime() - minDate.getTime()) / (1000 * 60)) * targetScale;
    const nowPositionPx = (nowOffsetMs / totalTimeSpanMs) * estimatedTotalWidth;

    setTimeout(() => {
      if (scrollWrapperRef.current) {
        const containerWidth = scrollWrapperRef.current.clientWidth;
        scrollWrapperRef.current.scrollLeft = nowPositionPx - (containerWidth / 2);
      }
    }, 50);
  };

  const handleFitConnectedStagesToScreen = () => {
    if (!selectedZamowienieId || !scrollWrapperRef.current || !minDate || !maxDate) return;

    const connectedStages = stages.filter(stage => stage.zamowienie_id === selectedZamowienieId);

    if (connectedStages.length === 0) return;

    const startTimes = connectedStages.map(s => new Date(s.start).getTime());
    const endTimes = connectedStages.map(s => new Date(s.end).getTime());

    const earliestStartMs = Math.min(...startTimes);
    let latestEndMs = Math.max(...endTimes);

    const shipmentDateRaw = selectedShipmentDate || connectedStages.find(s => s.data_spedycji)?.data_spedycji;

    if (shipmentDateRaw) {
      const shipmentDateObj = new Date(shipmentDateRaw);
      shipmentDateObj.setHours(6, 0, 0, 0);

      const shipmentPlus6hMs = shipmentDateObj.getTime() + (6 * 60 * 60 * 1000);

      if (shipmentPlus6hMs > latestEndMs) {
        latestEndMs = shipmentPlus6hMs;
      }
    }

    const durationMinutes = (latestEndMs - earliestStartMs) / (1000 * 60);
    if (durationMinutes <= 0) return;

    const containerWidth = Math.max(200, scrollWrapperRef.current.clientWidth - 60);

    let calculatedScale = containerWidth / durationMinutes;
    calculatedScale = Math.min(Math.max(calculatedScale, 0.01), 5.0);

    setScaleFactor(calculatedScale);

    const totalChartDurationMs = maxDate.getTime() - minDate.getTime();
    const startOffsetMs = earliestStartMs - minDate.getTime();
    const rangeDurationMs = latestEndMs - earliestStartMs;

    const estimatedTotalWidth = (totalChartDurationMs / (1000 * 60)) * calculatedScale;
    const rangeLeftPx = (startOffsetMs / totalChartDurationMs) * estimatedTotalWidth;
    const rangeWidthPx = (rangeDurationMs / totalChartDurationMs) * estimatedTotalWidth;

    const rangeCenterPx = rangeLeftPx + (rangeWidthPx / 2);

    setTimeout(() => {
      if (scrollWrapperRef.current) {
        const currentContainerWidth = scrollWrapperRef.current.clientWidth;
        scrollWrapperRef.current.scrollLeft = rangeCenterPx - (currentContainerWidth / 2);
      }
    }, 50);
  };

  const handleScrollToStart = () => {
    if (scrollWrapperRef.current) {
      scrollWrapperRef.current.scrollTo({
        left: 0,
      });
    }
  };

  const handleScrollToEnd = () => {
    if (scrollWrapperRef.current) {
      scrollWrapperRef.current.scrollTo({
        left: scrollWrapperRef.current.scrollWidth,
      });
    }
  };

  const handleSearch = ({ nr, rok, mode }) => {
    setSearchMode(mode);

    if (mode === 'archive') {
      console.log(`[API Archiwum] Pobieranie zamówienia Nr: ${nr}, Rok: ${rok}`);
      alert(`Później...`);
      return;
    }

    const matched = stages.filter((stage) => {
      const matchNr = String(stage?.nr || '').trim() === String(nr).trim();
      const matchRok = rok ? String(stage?.rok || '').trim() === String(rok).trim() : true;
      return matchNr && matchRok;
    });

    const matchedIds = matched.map(s => s.global_id);
    setSearchResults(matchedIds);
    setIsSearchActive(true);

    if (matched.length > 0) {
      handleCenterOnStage(matched[0]);
      setSelectedZamowienieId(matched[0].zamowienie_id);
      setSelectedShipmentDate(matched[0].data_spedycji);
    }
  };

  const handleClearSearch = () => {
    setSearchResults([]);
    setIsSearchActive(false);
  };

  // Funkcja łącząca zaznaczenie zamówienia/etapu z wycentrowaniem na wykresie
const handleSelectStage = (stage) => {
  if (!stage) return;
  setGrupaWykonan([]);
  setSelectedGrup(stage);
  setSelectedZamowienieId(stage.zamowienie_id);
  setSelectedShipmentDate(stage.data_spedycji);
  // Ustawienie efektu mrugania na 2 sekundy
  const stageId = stage.global_id || stage.id;
  setFlashingStageId(stageId);

  setTimeout(() => {
    setFlashingStageId(null);
  }, 2000);
  // Wycentrowanie wykresu Gantta na wybranym klocku
  // handleCenterOnStage(stage);
};


const handleSelectAndCenterStage = (stage) => {
  if (!stage) return;
  setGrupaWykonan([]);
  setSelectedGrup(stage);
  setSelectedZamowienieId(stage.zamowienie_id);
  setSelectedShipmentDate(stage.data_spedycji);
  // Ustawienie efektu mrugania na 2 sekundy
  const stageId = stage.global_id || stage.id;
  setFlashingStageId(stageId);

  setTimeout(() => {
    setFlashingStageId(null);
  }, 2000);
  // Wycentrowanie wykresu Gantta na wybranym klocku
  handleCenterOnStage(stage);
};



  return (
    <div className={styles.chartContainer}>
{/* TOP: Pasek sterowania */}
<div 
  className={styles.header}
  onDoubleClick={() => { console.log(contextApp.decodedToken); }}
>
  <div className={styles.btnFormContainer}>
    <GanttSearch 
      onSearch={handleSearch} 
      onClear={handleClearSearch}
      onModeChange={(mode) => setSearchMode(mode)}
    />
  </div>
  
  <div className={styles.controls}>

    {/* 1. Wybór procesora i przycisk tworzenia nowego okienka */}


    {/* 2. Menu z listą otwartych okienek */}
  

    {/* 3. Dotychczasowe przyciski sterujące */}
    <button 
      className={styles.scrollToNowBtn}
      onClick={() => setShowSingleConection(prev => !prev)}
      style={{ backgroundColor: showSingleConection ? '#19675e' : '#63636396' }}
      title="Połączenia sąsiednich procesów"
    >
      <Spline size={20} style={{ marginRight: "0px" }} />
    </button>

    <button 
      className={styles.scrollToNowBtn}
      onClick={() => setShowElementConections(prev => !prev)}
      style={{ backgroundColor: showElementConections ? '#19675e' : '#63636396' }}
      title="Połączenia z procesami"
    >
      <Waypoints size={20} style={{ marginRight: "0px" }} />
    </button>

    <button 
      className={styles.scrollToNowBtn}
      onClick={() => setShowOprawaConnections(prev => !prev)}
      style={{ backgroundColor: showOprawaConnections ? '#19675e' : '#63636396' }}
      title="Połączenia z oprawą"
    >
      <Waypoints size={20} style={{ marginRight: "0px", rotate: '90deg' }} />
    </button>

    <button 
      className={styles.scrollToNowBtn}
      onClick={() => setMoveable(prev => !prev)}
      style={{ backgroundColor: moveable ? '#8abe11' : '#63636396' }}
      title="Przenoszenie klocka"
    >
      <Move size={20} style={{ marginRight: "0px" }} />
    </button>

    <button 
      className={styles.scrollToNowBtn}
      onClick={() => setResizable(prev => !prev)}
      style={{ backgroundColor: resizable ? '#8abe11' : '#63636396' }}
      title="Rozciąganie klocka"
    >
      <Scaling size={20} style={{ marginRight: "0px" }} />
    </button>

    <button 
      className={styles.scrollToNowBtn}
      onClick={() => setIsSnapping(prev => !prev)}
      style={{ backgroundColor: isSnapping ? '#8abe11' : '#63636396' }}
      title="Przyciąganie klocka do pełnej godziny"
    >
      <Magnet size={20} style={{ marginRight: "0px" }} />
    </button>

    <button 
      className={styles.scrollToNowBtn}
      onClick={() => setShowFinishedBreaks(prev => !prev)}
      style={{ backgroundColor: showFinishedBreaks ? '#19675e' : '#63636396' }}
      title={showFinishedBreaks ? "Ukryj zakończone przerwy" : "Pokaż zakończone przerwy"}
    >
      <BetweenVerticalEnd size={20} style={{ marginRight: '0px' }} />
    </button>

    <button 
      title="Zamknij"
      style={{ background: 'transparent', border: 'none', marginRight: '10px' }}
      onClick={() => { navigate("/Panel"); }}
    >
      <X style={{ marginLeft: '20px', color: '#ffffffd4', height: '30px', width: '30px', padding: '5px', backgroundColor: '#ff0000', borderRadius: '5px' }} size={10} />
    </button>
  </div>
</div>

      {/* CENTER: Obszar roboczy */}
      <div className={styles.chartCenter}>
        <div className={styles.ganttWrapper}>
          
          {/* Lewa kolumna: Lista procesorów */}
<div 
  className={styles.stageNamesList} 
  ref={stageNamesListRef}
  onWheel={(e) => {
    if (scrollWrapperRef.current) {
      scrollWrapperRef.current.scrollTop += e.deltaY;
    }
  }}
>
  <div className={styles.timelineHeaderSpacer} />

  <div className={styles.rowsContentContainer}>
    {groupedStages && Object.keys(groupedStages).map(processorId => (
      <div key={`names-group-${processorId}`} className={styles.processorRow}>
        <div 
          className={styles.processorNameFixed} 
          title={`Kliknij, aby otworzyć okno (ProcesorID: ${processorId})`}
          onClick={() => floatingWindowsRef.current?.addWindow(processorId)}
          style={{ cursor: 'pointer' }}
        >
          {procesory.find(x => x.id == processorId)?.nazwa}
        </div>
      </div>
    ))}
  </div>

  <div className={styles.scrollbarSpacer} />
</div>

          {/* Prawa kolumna: Wykres i kalendarz */}
          <div 
            className={styles.scrollWrapper} 
            ref={scrollWrapperRef} 
            onScroll={handleMainScroll}
          >
            <div
              ref={chartRef}
              className={styles.ganttChart}
              style={{ width: `${totalChartWidth}px`, position: 'relative' }}
            >
              {/* Zostaje w miejscu podczas przewijania pionowego (sticky: top 0) */}
              <div className={styles.timeline}>
                <div className={styles.timelineMarkersContainer}>
                  {renderTimelineMarkers('top')}
                </div>
                <div className={styles.timelineLine}></div>
              </div>

              {renderWeekendBackgrounds()}
              {renderHourLines()}

              <GanttConnections
                groupedStages={groupedStages}
                processorIds={processorIds}
                rowYPositions={rowYPositions}
                minDate={minDate}
                maxDate={maxDate}
                totalChartWidth={totalChartWidth}
                selectedZamowienieId={selectedZamowienieId}
                showAllConections={showAllConections}
                showElementConections={showElementConections}
                calculateBarProperties={calculateBarProperties}
              />
              <GanttOprawaConnections
                groupedStages={groupedStages}
                processorIds={processorIds}
                rowYPositions={rowYPositions}
                minDate={minDate}
                maxDate={maxDate}
                totalChartWidth={totalChartWidth}
                selectedZamowienieId={selectedZamowienieId}
                showOprawaConnections={showOprawaConnections}
                calculateBarProperties={calculateBarProperties}
              />

              <GanttConectionSingle
                groupedStages={groupedStages}
                processorIds={processorIds}
                rowYPositions={rowYPositions}
                minDate={minDate}
                maxDate={maxDate}
                totalChartWidth={totalChartWidth}
                selectedZamowienieId={selectedZamowienieId}
                showSingleConection={showSingleConection}
                selectedStageId={selectedGrup?.id || selectedGrup?.global_id}
                selectedGrup={selectedGrup}
                calculateBarProperties={calculateBarProperties}
              />

              {isResizing && (
                <div 
                  className={styles.resizeGuideLine} 
                  style={{ left: `${resizingLeftPx}px` }}
                />
              )}

              <div className={styles.nowLine} style={{ left: `${calculateNowPosition()}px` }}>
                {/* <span className={styles.nowLabel}>TERAZ</span> */}
              </div>  

              {selectedShipmentDate && (
                <div 
                  className={styles.nowLine} 
                  style={{ left: `${calculateShipmentPosition()}px`, backgroundColor: '#ff4d4f' }}
                >
                  <span className={styles.nowLabelSpedycja} style={{ backgroundColor: '#ff4d4f', color:' #000000' }}>SPEDYCJA</span>
                </div>
              )}

              {groupedStages && Object.keys(groupedStages).map(processorId => (
                <div key={`bars-group-${processorId}`} className={styles.processorRow}>
                  <div className={processorId == 8 || processorId == 10 ? styles.processorBarsGroupOprawa : styles.processorBarsGroup}>
                    {groupedStages[processorId].map(stage => {
                      const { width, marginLeft, widthPx: baseWidthPx } = calculateBarProperties(stage.start, stage.end);
                      const barColor = getColor(stage, stage.technologia_id, stage.zamowienie_id, colorFrom);
                      const isSelected = selectedZamowienieId === stage.zamowienie_id;
                      const barOutlineSelected = getOutlineSelected(stage);
                      const barOutline = getOutline(stage);
                      const isCurrentlyResizing = isResizing && resizingStage?.global_id === stage.global_id;
                      
                      const finalWidth = isCurrentlyResizing ? `${currentWidthPx}px` : width;
const isFlashing = (stage.global_id || stage.id) === flashingStageId;
                      return (
                        <div
                          key={`1bar-${stage.global_id}`}
                          className={`${styles.stageBar} ${isFlashing ? styles.flashingBar : ''}`}
                          onContextMenu={(e) => {
                            if(canDragOnGant(stage.proces_nazwa_id)){
                              setGrupaWykonan([]);
                              const isSame = selectedZamowienieId === stage.zamowienie_id;
                              setSelectedGrup(stage);
                              setSelectedZamowienieId(stage.zamowienie_id);
                              setSelectedShipmentDate(isSame ? null : stage.data_spedycji);
                              e.preventDefault();
                              setContextMenu({ x: e.clientX, y: e.clientY, stage: stage });
                            }
                          }}
                          style={{
                            width: finalWidth,
                            marginLeft,
                            background: barColor,
                            border: isSelected ? barOutlineSelected : barOutline,
                            outlineOffset: '2px',
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            setGrupaWykonan([]);
                            const isSame = selectedZamowienieId === stage.zamowienie_id && selectedGrup?.id === stage.id;
                            setSelectedZamowienieId(isSame ? null : stage.zamowienie_id);
                            setSelectedShipmentDate(isSame ? null : stage.data_spedycji);
                            setSelectedGrup(isSame ? null : stage);
                          }}
                          draggable={canDragOnGant(stage.proces_nazwa_id) && moveable && !isResizing}
                          onDragOver={(event) => { handleDragOver(stage, event); }}
                          onDrop={(event) => { handleDrop(stage, event); }}
                          onDragStart={(event) => { handleDragStart(stage, event); }}
                          title={` ${stage.nr || ''} ${stage.rok || ''} ${stage.firma_nazwa || ''} ${stage.tytul || ''} \n 
od: ${date_time(stage.start)}  do: ${date_time(stage.end)} 
Ilość narządów: ${stage.ilosc_narzadow || '--'}
Przeloty: ${stage.przeloty || '--'} szt.
Spedycja: ${date_bez_time(stage.data_spedycji) || '--'}
Status: ${stage.status}
Element: ${getNameOfElementTyp(stage.typ_elementu, contextApp.typ_elementu) || '--'} 
Typ grupy: ${stage.typ_grupy}
Proces nazwa id: ${stage.proces_nazwa_id}
Zamówienie ID : ${stage.zamowienie_id}
ARKUSZE ID : ${stage.arkusze_id || 'brak'}
ELEMENT ID : ${stage.element_id || 'brak'}
elementy_id : ${stage.elementy_id || 'brak'}
TECHNOLOGIA ID : ${stage.technologia_id || 'brak'}
indeks_procesu: ${stage.indeks_procesu || 'brak'}
`}
                        >
                          <span className={styles.nameText}>
                            {` ${stage.firma_nazwa || `Przerwa`}`}
                          </span>

                          {isCurrentlyResizing && resizingEndDate && (
                            <div className={styles.resizeTooltip}>
                              {resizingEndDate.toLocaleString('pl-PL', { 
                                month: '2-digit', 
                                day: '2-digit', 
                                hour: '2-digit', 
                                minute: '2-digit' 
                              })}
                            </div>
                          )}

                          {resizable && (
                            <div
                              className={styles.resizeHandleRight}
                              onMouseDown={(e) => {
                                if(canDragOnGant(stage.proces_nazwa_id)){
                                  e.stopPropagation();
                                  e.preventDefault();
                                  setResizingStage(stage);
                                  setResizeStartX(e.clientX);
                                  setCurrentWidthPx(baseWidthPx);
                                  setResizingEndDate(new Date(stage.end));
                                  const { leftPx } = calculateBarProperties(stage.start, stage.end);
                                  setResizingLeftPx(leftPx + baseWidthPx);
                                }
                              }}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM: Stopka */}
      <div className={styles.chartBottom}>
                  <div
                   className={styles.navigationBtnLeft}  >
          {selectedZamowienieId ? (
            <div className={styles.infoHeader}>
              {selectedGrup?.nr}_{selectedGrup?.rok.substring(2, 4)}  <span style={{ fontWeight: "normal",marginRight:'10px',marginLeft:'10px', textTransform:'uppercase', fontSize:"12px",marginTop:"3px" }}>  {getNameOfElementTyp(selectedGrup?.typ_elementu, contextApp.typ_elementu)}  </span> {selectedGrup?.firma_nazwa} {selectedGrup?.tytul}
            </div>
          ) : (
            <></>
          )}
          </div>
        <div   className={styles.navigationBtnCenter} >
          {/* <span>Zoom:</span> */}


          <button 
            className={styles.scrollToNowBtn} 
            onClick={handleScrollToStart}
            title="Przejdź do początku wykresu"
          >
            <ChevronsLeft size={18} style={{ marginRight: '4px' }} />
          </button>

          <button className={styles.scrollToNowBtn} onClick={handleScrollToNow}>
            Teraz
          </button>

          <button 
            className={styles.scrollToNowBtn} 
            onClick={handleScrollToEnd}
            title="Przejdź do końca wykresu"
          >
            <ChevronsRight size={18} style={{ marginLeft: '4px' }} />
          </button>
          
          </div>

          <div className={styles.navigationBtnRight}> 
                      <button
            className={styles.scrollToNowBtn}
            onClick={handleFitConnectedStagesToScreen}
            disabled={!selectedZamowienieId}
            style={{
              backgroundColor: selectedZamowienieId ? '#2a9d8f' : '#63636396',
              cursor: selectedZamowienieId ? 'pointer' : 'not-allowed'
            }}
            title="Dopasuj zaznaczenie do ekranu"
          >
            <Shrink size={20} style={{ marginRight: "0px" }} />
          </button>
            {[0.05, 0.10, 0.15, 0.25, 0.5, 1.0, 2.0].map((val) => (
              <button
              key={val}
              onClick={() => handleCenterOnNow(val)}
              style={{
                padding: '4px 8px',
                backgroundColor: scaleFactor === val ? '#2a9d8f' : '#f0f0f0',
                color: scaleFactor === val ? '#fff' : '#000',
                border: '1px solid #ccc',
                cursor: 'pointer',
                borderRadius: '4px'
              }}
              >
                {val}x
              </button>
              

            ))}
{/* <ScanSearchIcon size={30} color="yellowgreen" style={{ marginBottom: '1px',marginLeft:"3px"}} /> */}
  <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={styles.scrollToNowBtn}
        onClick={() => setShowWindowsMenu((prev) => !prev)}
        style={{
          backgroundColor: openWindowsList.length > 0 ? '#19675e' : '#63636396',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
        title="Zarządzaj otwartymi okienkami"
      >
        <Layers size={18} />
        <span>Otwarte ({openWindowsList.length})</span>
      </button>

      {showWindowsMenu && (
        <div
          style={{
            position: 'absolute',
            // top: '100%',
            top:`auto`,
            bottom:`100%`,
            right: 0,
            marginBottom: '6px',
            width: '260px',
            backgroundColor: '#1f2937',
            color: '#ffffff',
            border: '1px solid #374151',
            borderRadius: '6px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.5)',
            zIndex: 100,
            padding: '8px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: '6px',
              marginBottom: '6px',
              borderBottom: '1px solid #374151',
              fontSize: '12px',
              fontWeight: 600,
            }}
          >
            <span>Otwarte okienka ({openWindowsList.length})</span>
            {openWindowsList.length > 0 && (
              <button
                onClick={() => {
                  floatingWindowsRef.current?.closeAll();
                  setShowWindowsMenu(false);
                }}
                style={{
                  background: '#ef4444',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '3px',
                  padding: '2px 6px',
                  fontSize: '10px',
                  cursor: 'pointer',
                }}
              >
                Zamknij wszystkie
              </button>
            )}
          </div>

          {openWindowsList.length === 0 ? (
            <div style={{ fontSize: '11px', color: '#9ca3af', textAlign: 'center', padding: '8px 0' }}>
              Brak otwartych okienek
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '200px', overflowY: 'auto' }}>
              {openWindowsList.map((win) => {
                const procName =
                  procesory?.find((p) => Number(p.id) === Number(win.procesor_id))?.nazwa || win.title;
                return (
                  <div
                    key={win.id}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '4px 8px',
                      backgroundColor: '#374151',
                      borderRadius: '4px',
                      fontSize: '11px',
                    }}
                  >
                    <span
                      onClick={() => {
                        floatingWindowsRef.current?.bringToFront(win.id);
                        setShowWindowsMenu(false);
                      }}
                      style={{
                        cursor: 'pointer',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '180px',
                      }}
                      title="Kliknij, aby wyciągnąć na wierzch"
                    >
                      {procName} {win.isMinimized ? ' (zmin.)' : ''}
                    </span>
<div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <button
          onClick={() => {
            floatingWindowsRef.current?.centerWindow(win.id);
            setShowWindowsMenu(false);
          }}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#60a5fa',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            padding: '2px',
          }}
          title="Wycentruj okienko na ekranie"
        >
          <Focus size={14} />
        </button>

        <button
          onClick={() => floatingWindowsRef.current?.closeWindow(win.id)}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#f87171',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            padding: '2px',
          }}
          title="Zamknij okienko"
        >
          <X size={14} />
        </button>
      </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
          </div>
      </div>

      <GanttContextMenu
        setModalGrupyOpen={setModalGrupyOpen}
        contextMenu={contextMenu}
        onClose={() => setContextMenu(null)}
        onShowDetails={(stage) => {
          alert(`Szczegóły dla etapu: ${stage.name}`);
        }}
        onSelectOrder={(stage) => {
          setSelectedZamowienieId(stage.zamowienie_id);
          setSelectedShipmentDate(stage.data_spedycji);
        }}
        handleCenterOnStage={handleCenterOnStage}
        minDate={minDate}
      />
      <ModalGrupyTechnologii 
        modalGrupyOpen={modalGrupyOpen} 
        setModalGrupyOpen={setModalGrupyOpen} 
        contextMenu={contextMenu} 
        selectedGrup={selectedGrup} 
      />
<FloatingWindows 
ref={floatingWindowsRef}
  procesory={procesory}
  groupedStages={groupedStages}
  onSelectAndCenterStage={handleSelectAndCenterStage}
  onSelectStage={handleSelectStage}
  
  
  onWindowsChange={setOpenWindowsList}
      />
    </div>
  );
};

export default GanttChartAll;